import gql from 'graphql-tag'

export const APPLICATION_FILE_TYPES_QUERY = gql`
    query applicationFileTypes(
        $status: ApplicationFileTypeStatus = ACTIVE
    ) {
        applicationFileTypes(
            status: $status
        ) {
            id
            status
            key
            name
        }
    }
`
